module.exports = __webpack_public_path__ + "img/level_six.e1684edc.png";